/* eslint-disable no-nested-ternary */
import Modal from "components/atoms/modal";
import { CloseIcon } from "components/atoms/Icon";
import Button from "components/atoms/buttons/Button";
import { useUserContext } from "components/context/UserContext";
import { getLoginPageURLWithRedirect } from "utils/HelperFunctions";
import { toast } from "react-toastify";
import { useRouter } from "components/hooks";
import { useLoaderContext } from "components/context/LoaderContext";
// eslint-disable-next-line import/no-cycle
import IncentivesCard from "./IncentivesCard";
import { TOAST_CONFIG } from "../../../constants";

type Props = {
  incentiveData: IncentiveMemento;
  pollsResponded: string[];
  socialShareResponded: string[];
  isOpen: boolean;
  onClose: () => void;
};

function IncentiveModal({ incentiveData, pollsResponded, socialShareResponded, isOpen, onClose }: Props) {
  const { isUserLoggedIn, setCurrentlyViewingMementoId } = useUserContext();
  const { setLoading } = useLoaderContext();
  const { go } = useRouter();
  return (
    <Modal open={isOpen} onClose={onClose} closeOnOutsideClick={false}>
      <div className="relative w-[97vw] max-w-[40rem] rounded-2xl bg-primary px-1 pb-8 pt-2">
        <button className=" absolute right-0 mr-4 mt-4" type="button" onClick={onClose}>
          <CloseIcon className="h-4 w-4 text-white" />
        </button>
        <IncentivesCard
          isPreview={false}
          incentiveData={incentiveData as any}
          shareRequestsResponded={socialShareResponded}
          pollsResponded={pollsResponded}
        />
        {incentiveData.description && (
          <p className="mb-6 px-7 text-xxs text-white">
            <span className="text-sm font-semibold">Description:</span> {incentiveData.description}
          </p>
        )}
        <div className="mt-2 flex justify-center">
          <Button
            text={
              isUserLoggedIn
                ? incentiveData.owns
                  ? incentiveData.action_pending
                    ? "GRAB YOUR INCENTIVE"
                    : "VIEW INCENTIVE"
                  : "COMPLETE GOALS TO GET INCENTIVES"
                : "SIGN IN AND BUY MAGNET TO PROCEED"
            }
            onClick={() => {
              if (incentiveData.owns) setCurrentlyViewingMementoId(incentiveData.id);
              else {
                toast.info(
                  isUserLoggedIn
                    ? "Complete goals to Claim Incentive!"
                    : "Login and buy the Magnet to proceed! Redirecting to sign in Page.",
                  TOAST_CONFIG,
                );
                if (!isUserLoggedIn) {
                  setLoading(true, "Redirecting....");
                  setTimeout(() => {
                    setLoading(false);
                    go(getLoginPageURLWithRedirect());
                  }, 3000);
                }
              }
            }}
            additionalClasses="!text-base !xl:text-xxs px-3 py-1 xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            variant="magnetiqSolid"
          />
        </div>
      </div>
    </Modal>
  );
}
export default IncentiveModal;
